import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const createCheckout = async () => {
  const referral = localStorage.getItem("miria_referral");
  const { data } = await axios.post(`${API}/payments/checkout`, {
    lookup_key: "miria_starter_yearly",
    origin_url: window.location.origin,
    referral_code: referral || undefined,
  });
  return data;
};

export const getPaymentStatus = async (sessionId) => {
  const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
  return data;
};
